<template>
  <span class="a-deaccessioned-tag">
    {{ deaccessionedText }}
  </span>
</template>

<script>
import { useLocalization } from "@thegetty-private/getty-ui";

export default {
  name: "DeaccessionTag",
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      /**
       * Translated text to display for a deaccessioned item
       */
      deaccessionedText: this.translatePart(`image_and_caption.deaccessioned`)
    };
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
